// What the admin dashboard says about server drafts (Round 2 PR D). The Function App tells us the mode
// (/api/forms/runtime-config: draft_retention), so the dashboard never promises a deletion that isn't on.

export function lastSaveOf(a) {
  return (a && (a.last_saved || (a.metadata && a.metadata.last_saved_timestamp) || a.timestamp || (a.metadata && a.metadata.created_timestamp))) || null;
}

export function deletesOnText(a, days = 30) {
  const t = Date.parse(lastSaveOf(a) || "");
  if (Number.isNaN(t)) return "";
  const d = new Date(t + days * 24 * 60 * 60 * 1000);
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric", timeZone: "Australia/Sydney" });
}

export function retentionNote(retention) {
  if (!retention) return "";
  const days = retention.days || 30;
  if (retention.mode === "delete") return `Drafts are deleted ${days} days after the last save.`;
  if (retention.mode === "dry_run") return `Drafts with no save for ${days} days will be deleted once this is switched on (counting only for now).`;
  return "";
}

export function draftRowNote(a, retention) {
  if (!retention || (retention.mode !== "delete" && retention.mode !== "dry_run")) return "";
  const when = deletesOnText(a, retention.days || 30);
  if (!when) return "";
  return retention.mode === "delete" ? `Deletes on ${when}` : `Would delete on ${when}`;
}
